<template>
  <zen-one :showuserinfo="false" title="" :crumbs="crumbs">
	  <z-page :title="title">
      <w-form class="" v-model="form.valid" v-model:errors-count="form.errorsCount" @validate="onValidate" @success="onSuccess()" >
        <w-flex gap="3">
          <div class="box xs6">
            <template v-if="form.hantar==2">
              <w-input class="mt4" label="Tarikh *" type="date" v-model="form.tarikh" :validators="[validators.required]" outline/>
              <w-input class="mt4" label="Nama *" type="text" v-model="form.nama" readonly :validators="[validators.required]" outline/>
              <z-select class="mt4" :items="lkp_negeri" label="Negeri Mohon" readonly v-model="form.lkp_negeri_id" :validators="[validators.required]" outline/>
            </template>
            <template v-else>
              <table >
                <tbody>
                  <tr class="row_data">
                    <td><b>Tarikh</b></td>
                    <td><b>:</b></td>
                    <td>{{ $zutil.dateformat(form.tarikh)}}</td>
                  </tr>
                  <tr class="row_data">
                    <td><b>Nama</b></td>
                    <td><b>:</b></td>
                    <td>{{form.nama}}</td>
                  </tr>
                  <tr class="row_data">
                    <td><b>Negeri Mohon</b></td>
                    <td><b> : </b></td>
                    <td>{{form.lkpNegeri_label}}</td>
                  </tr>
                </tbody>
              </table>
            </template>
          </div>
        </w-flex><br><br>
        <template v-if="$zutil.anyRole(['4']) && $zutil.anyCan(['3'])">
          <div class="table-responsive"> <!-- Untuk Pengesahan Penyelaras -->
            <table class="w-table">
              <thead>
                  <tr>
                      <th class="w-table__header w-table__header--sortable text-center" width="1px">Bil</th>
                      <th class="w-table__header w-table__header--sortable text-center">Kuantiti Dimohon</th>
                      <th class="w-table__header w-table__header--sortable text-center">Jenis Ternakan</th>
                      <th class="w-table__header w-table__header--sortable text-center">Jurusan</th>
                      <th class="w-table__header w-table__header--sortable text-center">Baka Ternakan</th>
                      <th class="w-table__header w-table__header--sortable text-center">Tujuan/Justifikasi/Catatan</th>
                      <th class="w-table__header w-table__header--sortable text-center">Batch Nombor</th>
                      <th class="w-table__header w-table__header--sortable text-center">Kuantiti Diluluskan</th>
                      <th class="w-table__header w-table__header--sortable text-center"></th>
                  </tr>
              </thead>
              <tbody>
                <tr v-for="(dt, index) in form.butiran" :key="index">
                  <td class="w-table__cell text-center" width="1px">
                    {{index+1}}
                  </td>
                  <td class="w-table__cell text-center">
                    {{dt.kuantiti}}
                  </td>
                  <td class="w-table__cell text-center">
                    {{dt.label_ternakan}}
                  </td>
                  <td class="w-table__cell text-center">
                    {{dt.label_jurusan}}
                  </td>
                  <td class="w-table__cell text-center">
                    {{dt.label_baka}}
                  </td>
                  <td class="w-table__cell text-center">
                    {{dt.catatan}}
                  </td>
                  <td class="w-table__cell text-lift">
                    <div v-for="stock in dt.stock" >
                      <p style="margin:5px; ">{{stock.no_batch}}</p>
                    </div>
                    <div v-if="dt.kuantiti > dt.jumlah_stock">
                      <w-select placeholder="Sila Pilih" :items="dt.no_batch_ibvk" v-model="dt.se_stock_id" @input="getNoBatch(dt)" :validators="[validators.required]"/>
                    </div>
                    
                  </td>
                  <td class="w-table__cell text-right">
                    <div v-for="stock in dt.stock" >
                      <w-input type="number" v-model="stock.kuantiti" :readonly="form.lkp_status_id!=16" :max="stock.kuantiti_asal" @keydown="debouncedSaveKuantiti(dt, stock)" @keyup="kuantitiLulus(stock.id, stock, dt)" :validators="[validators.required]"/>
                    </div>
                    <div v-if="dt.kuantiti > dt.jumlah_stock">
                      <w-input type="number" v-model="dt.kuantiti_lulus" :max="dt.kuantiti" readonly :validators="[validators.required]"/>
                    </div>
                  </td>
                  <td class="w-table__cell text-center">
                    <div v-for="stock in dt.stock" >
                      <w-icon class="mr1" v-if="form.lkp_status_id==16" @click="removeStok(stock)" style="margin:5px; ">fal fa-trash</w-icon>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td class="w-table__cell text-center" width="1px"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-left">Jumlah Diluluskan</td>
                  <td class="w-table__cell text-right">{{form.kuantiti_lulus}}</td>
                </tr>
                <tr>
                  <td class="w-table__cell text-center" width="1px"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-center"></td>
                  <td class="w-table__cell text-left">Jumlah Tidak Lulus</td>
                  <td class="w-table__cell text-right">{{form.kuantiti_tidak_lulus}}</td>
                </tr>
              </tbody>
            </table>
          </div><br>
        </template>
         
        <w-flex class="mt3" wrap align-center justify-end>
          <template v-if="$zutil.anyRole(['4']) && $zutil.anyCan(['3'])">
           <w-button class="my1" v-if="form.lkp_status_id==16"
              bg-color="error-dark1"
              dark tile
              @click="tolakDialog()"
            >
              <w-icon xs class="mr2">fal fa-times</w-icon> TOLAK
            </w-button>
            &nbsp;
            <w-button class="my1" v-if="form.lkp_status_id==16" bg-color="success" type="submit" :disabled="form.valid === false" :loading="form.submitted && !form.sent" @click="send(4)">
             <w-icon xs class="mr2">fal fa-paper-plane</w-icon> LULUS
           </w-button>
          </template>
        </w-flex>
        <div class="mt2 text-left">
          <w-button style="
                  background-color: #f0f0f0; 
                  border: 2px solid red; 
                  color: #333; 
                  padding: 7px 14px; 
                  font-size: 11px; 
                  font-weight: bold; 
                  border-radius: 4px; 
                  cursor: pointer;
              " @click="tutup">TUTUP</w-button>&nbsp;
       </div>
      </w-form>
	  </z-page>
      <w-dialog
        v-model="dialogTolak.show"
        title="Catatan"
        width="600"
        title-class="primary-dark1--bg white"
      >
        <w-form v-model="dialogTolak.valid" ref="formTolak">
          <w-textarea
            v-model="dialogTolak.catatan_tindakan"
            label="Catatan"
            placeholder="Masukkan catatan tindakan anda..."
            rows="4"
            required
          />
        </w-form>

        <template #actions>
          <w-button bg-color="grey-light5--bg" @click="dialogTolak.show = false">
            BATAL
          </w-button>
          &nbsp;
          <w-button bg-color="success" dark @click="sahkanTolak()">
            HANTAR
          </w-button>
        </template>
      </w-dialog>

  </zen-one>
</template>

<script>
import { reactive } from 'vue'
import ZResource from '@/Modules/z-resource'
import { nextTick } from 'vue';



export default {
  extends: ZResource,
  props: {
    d_form: [Array, Object],
    d_lkp_negeri:[Array, Object],
    d_lkp_ternakan : [Array, Object],
    d_lkp_baka: [Array, Object],
    d_lkp_ternakan: [Array, Object],
    d_lkp_jurusan: [Array, Object]
  },
  data() {
    return {
      resourceurl: 'se.permohonan.penyelaras-aiman',
      crumbs: [
        { label: this.$page.props.app_name, route: '/home' },
        { label: 'Pengurusan Semen Beku', route: '/se' },
        { label: 'Permohonan', route: '/se/permohonan' },
        { label: 'Semen AI MAN', route: '/se/permohonan/penyelaras-aiman' },
      ],
      title : 'Permohonan Semen Ai Man',
      form : this.d_form,
      dialogTolak: {
      show: false,
      valid: false,
      catatan_tindakan: ''
    },
      lkp_negeri: this.d_lkp_negeri,
      lkp_ternakan: this.d_lkp_ternakan,
      lkp_jurusan: this.d_lkp_jurusan,
      lkp_baka: this.d_lkp_baka,
      lkp_ternakan: this.d_lkp_ternakan,
      
    }
  },
  methods: {
    kuantitiLulus(id, stock, dt){
      if(stock.kuantiti > dt.jumlah_pemohonan){
        stock.kuantiti = dt.jumlah_pemohonan;
      }
    },
    tutup(){
      this.$inertia.visit(window.route('se.permohonan.penyelaras-aiman.index'));
    },
    removeStok(items) {
      this.$zcomm.delete(this.resourceurl + '.no_batch_negeri.destroy',items.id)
      .then(res => {
        this.getData(this.form.id);
        if (typeof this.onAfterDelete === "function") {
          this.onAfterDelete()
        }
      })
      .finally(() => {
        // $('#' + this.resourceurl).modal('hide')
      });
    },
    debouncedSaveKuantiti: _.debounce(function(dt, stock) {
      this.saveKuantitiDisetujui(dt, stock);
    }, 300), // Debounce untuk mencegah pemanggilan dua kali
    saveKuantitiDisetujui(item, stock){
      if(stock.kuantiti > item.jumlah_pemohonan){
        stock.kuantiti = item.jumlah_pemohonan
      }
      if(stock.kuantiti > 0 && stock.id > 0){
        this.$zcomm.post(this.resourceurl +'.no_batch_aiman', {
            id : item.id,
            user_id : item.user_id,
            se_permohonan_id : item.se_permohonan_id,
            lkp_status_id : item.lkp_status_id,
            lkp_ternakan_id : item.lkp_ternakan_id,
            jenis : item.jenis,
            se : item.se,
            seq : item.seq,
            lkp_jurusan_id : item.lkp_jurusan_id,
            lkp_baka_id : item.lkp_baka_id,
            kuantiti_asal : stock.kuantiti_asal,
            kuantiti_lulus : stock.kuantiti,
            catatan : item.catatan,
            tindakan : status,
            se_pendaftaran_id : item.se_pendaftaran_id,
            se_stock_id: item.se_stock_id,
            stock_id : stock.id,
            stock : stock,
            kemaskini : 1,
          })
        .then(res => {
          if (typeof this.onAfterEdit === "function") {
            this.onAfterEdit()
          }
          this.getData(this.form.id);
        })
      }
    },
    getNoBatch(item){
      this.$zcomm.get(this.api_service + 'lookup/no_batch_negeri/'+item.se+'/'+item.lkp_baka_id,{}).then(res => {
        item.no_batch_ibvk = res
        for (var i in item.no_batch_ibvk) {
          if(item.se_stock_id == item.no_batch_ibvk[i].value){
            if(item.no_batch_ibvk[i].baki > item.jumlah_pemohonan){
              item.kuantiti_lulus = item.jumlah_pemohonan
            }else{
              item.kuantiti_lulus =item.no_batch_ibvk[i].baki
            }
            //simpan
            this.$zcomm.post(this.resourceurl +'.no_batch_aiman', {
                id : item.id,
                user_id : item.user_id,
                se_permohonan_id : item.se_permohonan_id,
                lkp_status_id : item.lkp_status_id,
                lkp_ternakan_id : item.lkp_ternakan_id,
                jenis : item.jenis,
                se : item.se,
                seq : item.seq,
                lkp_jurusan_id : item.lkp_jurusan_id,
                lkp_baka_id : item.lkp_baka_id,
                kuantiti : item.kuantiti,
                kuantiti_lulus : item.kuantiti_lulus,
                catatan : item.catatan,
                tindakan : status,
                se_pendaftaran_id : item.se_pendaftaran_id,
                se_stock_id: item.se_stock_id,
                stock : item.stock,
              })
            .then(res => {
              if (typeof this.onAfterEdit === "function") {
                this.onAfterEdit()
              }
              this.$zutil.notify("Berjaya disimpan", true);
              this.getData(this.form.id);
            })
          }
        }
      })
    },
    addItem() {

      this.form.butiran.push({ 
        id:0,
        kuantiti: '', 
        lkp_ternakan_id: '', 
        lkp_jurusan_id:'', 
        lkp_baka_id:'', 
        catatan:'', 
        jenis:'',
        se:'',
        se_permohonan_id:'',
        kuantiti_disetujui:'',
        lkp_status_id:'',
        lkp_jurusan:[],
        lkp_baka:[] });
      // this.form.butiran.push({ id:0,kuantiti: '', lkp_ternakan_id: '', lkp_jurusan_id:'', lkp_baka_id:'', catatan:'', lkp_jurusan:[],lkp_baka:[] });
      this.$nextTick(() => {
      });
    },
    removeItem(index) {
        this.form.butiran.splice(index, 1);
    },

    getTernakan(){
      this.$zcomm.get(this.api_service + 'lookup/ternakan', {}).then(res => {
        this.lkp_ternakan = res
      })
    },

    getJurusan(item, i){
      this.$zcomm.get(this.api_service + 'lookup/jurusan/'+i, {}).then(res => {
        item.lkp_jurusan = res;
      })
    },

    getBaka(item,i){
      this.$zcomm.get(this.api_service + 'lookup/baka/'+i, {}).then(res => {
        item.lkp_baka = res
      })
    },

    tolakDialog() {
     this.dialogTolak.catatan_tindakan = ''
     this.dialogTolak.show = true
   },

   // 🔹 simpan tolak setelah isi catatan tindakan
   sahkanTolak() {
     if (!this.dialogTolak.catatan_tindakan || this.dialogTolak.catatan_tindakan.trim() === '') {
       this.$zutil.notify('Sila isi catatan tindakan sebelum menghantar.', false)
       return
     }

     this.$swal({
       title: 'Anda pasti untuk menolak?',
       icon: 'warning',
       showCancelButton: true,
       confirmButtonText: 'Ya, tolak!',
       cancelButtonText: 'Batal'
     }).then(result => {
       if (result.value) {
         this.form.hantar = 3
         this.form.catatan_tindakan = this.dialogTolak.catatan_tindakan
         this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
           .then(() => {
             this.$zutil.notify('Permohonan berjaya ditolak.', true)
             this.dialogTolak.show = false
             this.$inertia.visit(this.$route('se.permohonan.penyelaras-aiman.index'))
           })
       }
     })
   },

    send(hantar){
      this.form.hantar = hantar
    },
    onSuccess(){
      if (this.form.hantar==1 ||this.form.hantar==3||this.form.hantar==4 ) {
        this.$swal({
          title: 'Anda Pasti?',
          // text: "Are you sure want to delete this item!",
          type: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Ya',
          cancelButtonText: 'Tidak'
        }).then((result) => {
        if (result.value) {
          if (this.form.id > 0) 
          {
            this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
            .then(res => {
              if (typeof this.onAfterEdit === "function") {
                this.onAfterEdit()
              }
              this.$inertia.visit(this.$route('se.permohonan.penyelaras-aiman.index'))
            })
          }else{
            this.$zcomm.post(this.resourceurl+'.store' , this.form)
            .then(res => {
              if (typeof this.onAfterAdd === "function") {
                this.onAfterAdd()
              }
              this.$zutil.notify("Berjaya dihantar", true);
              this.$inertia.visit(this.$route('se.permohonan.penyelaras-aiman.index'))

            })
          }
        }else{ }
        })
      }else{
        if (this.form.id > 0) 
        {
          this.$zcomm.update(this.resourceurl + '.update', this.form.id, this.form)
          .then(res => {
            if (typeof this.onAfterEdit === "function") {
              this.onAfterEdit()
            }
            if (this.form.hantar==1) {
              this.$inertia.visit(this.$route('se.permohonan.penyelaras-aiman.index'));
            }else{
              this.$zutil.notify("Berjaya disimpan", true);
              this.getData(this.form.id);
            }
            this.$inertia.visit(this.$route('se.permohonan.penyelaras-aiman.form', res.id))
          })
        }else{
          this.$zcomm.post(this.resourceurl+'.store' , this.form)
          .then(res => {
            if (typeof this.onAfterAdd === "function") {
              this.onAfterAdd()
            }
            this.$zutil.notify("Berjaya disimpan", true);
            this.$inertia.visit(this.$route('se.permohonan.penyelaras-aiman.form', res.id))

          })
        }
      }
    },
    getData(id){
      if(id > 0){
        this.$zcomm.get(this.api_service + 'permohonan/aiman/'+id, {}).then(res => {
          this.form = res
        })
      }
    },



    
  
  },

  watch: {

  },
  mounted() {
    if (this.form.id == 0) {
      var today = new Date();
      this.form.tarikh = today.toISOString().split('T')[0];
      const user = this.$page?.props?.auth?.user;
      // console.log(user);

      if (!user) return;
      if (user.lkp_jenis_pengguna_id == 1 && this.$zutil.role('9')) {
        this.form.lkp_negeri_id = user.lkp_negeri_id;
      } else {
        this.form.lkp_negeri_id = user.lkp_diselia_negeri_id;
      }
      this.form.user_id = user.id;
      this.form.nama = user.name;

      this.title = 'Tambah Permohonan Semen AI MAN'
    }
    else
    {
      this.title = 'kemaskini Permohonan Semen AI MAN'
    }
   
    this.getTernakan();
    
  }
    
}
</script>
